import styles from './styles.module.scss';

function Skeleton() : JSX.Element {
  const Loader = () : JSX.Element => {
    return (
      <div className={styles['skeleton']}>
        <div className={styles['skeleton-content']}>
          <div className={styles['skeleton-loader-icon']}></div>
          <div className={styles['skeleton-loader-message']}>
            <div className={styles['skeleton-loader']}></div>
            <div className={styles['skeleton-loader']}></div>
            <div className={styles['skeleton-loader']}></div>
            <div className={styles['skeleton-loader']}></div>
          </div>
          <div className={styles['skeleton-loader-option']}></div>
        </div>
      </div>
    );
  };

  return <>{new Array(10).fill(0).map((_, i) => <Loader key={i}/>)}</>;
}

export default Skeleton;